export const LOAD_PLACEMARKS_REQUEST = "LOAD_PLACEMARKS_REQUEST";
export const LOAD_PLACEMARKS_SUCCESS = "LOAD_PLACEMARKS_SUCCESS";
export const LOAD_PLACEMARKS_FAILURE = "LOAD_PLACEMARKS_FAILURE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const LOGIN_ERRORS_CLEAR = "LOGIN_ERRORS_CLEAR";

export const LOAD_USERS_REQUEST = "LOAD_USERS_REQUEST";
export const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
export const LOAD_USERS_FAILURE = "LOAD_USERS_FAILURE";

export const LOAD_USER_DETAILS_REQUEST = "LOAD_USER_DETAILS_REQUEST";
export const LOAD_USER_DETAILS_SUCCESS = "LOAD_USER_DETAILS_SUCCESS";
export const LOAD_USER_DETAILS_FAILURE = "LOAD_USER_DETAILS_FAILURE";

export const DELETE_USER_REQUEST = "DELETE_USER_REQUEST";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const ADD_USER_REQUEST = "ADD_USER_REQUEST";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAILURE = "ADD_USER_FAILURE";

export const CLEAR_USER_ERROR = "CLEAR_USER_ERROR";

export const INIT_DATA_REQUEST = "INIT_DATA_REQUEST";
export const INIT_DATA_SUCCESS = "INIT_DATA_SUCCESS";
export const INIT_DATA_FAILURE = "INIT_DATA_FAILURE";

export const CLIENTS_UPDATE_CALLS_DATE_REQUEST =
  "CLIENTS_UPDATE_CALLS_DATE_REQUEST";
export const CLIENTS_UPDATE_CALLS_DATE_SUCCESS =
  "CLIENTS_UPDATE_CALLS_DATE_SUCCESS";
export const CLIENTS_UPDATE_CALLS_DATE_FAILURE =
  "CLIENTS_UPDATE_CALLS_DATE_FAILURE";

export const CLIENTS_LOAD_REQUEST = "CLIENTS_LOAD_REQUEST";
export const CLIENTS_LOAD_SUCCESS = "CLIENTS_LOAD_SUCCESS";
export const CLIENTS_LOAD_FAILURE = "CLIENTS_LOAD_FAILURE";

export const CLIENTS_FULL_LIST_LOAD_REQUEST = "CLIENTS_FULL_LIST_LOAD_REQUEST";
export const CLIENTS_FULL_LIST_LOAD_SUCCESS = "CLIENTS_FULL_LIST_LOAD_SUCCESS";
export const CLIENTS_FULL_LIST_LOAD_FAILURE = "CLIENTS_FULL_LIST_LOAD_FAILURE";

export const CLIENT_CROP_HISTORY_LOAD_REQUEST =
  "CLIENT_CROP_HISTORY_LOAD_REQUEST";
export const CLIENT_CROP_HISTORY_LOAD_SUCCESS =
  "CLIENT_CROP_HISTORY_LOAD_SUCCESS";
export const CLIENT_CROP_HISTORY_LOAD_FAILURE =
  "CLIENT_CROP_HISTORY_LOAD_FAILURE";

export const CLIENT_ADD_REQUEST = "CLIENT_ADD_REQUEST";
export const CLIENT_ADD_SUCCESS = "CLIENT_ADD_SUCCESS";
export const CLIENT_ADD_FAILURE = "CLIENT_ADD_FAILURE";

export const LOAD_SALES_ORDERS_OF_SUPPLIER_REQUEST = "LOAD_SALES_ORDERS_OF_SUPPLIER_REQUEST";
export const LOAD_SALES_ORDERS_OF_SUPPLIER_SUCCESS = "LOAD_SALES_ORDERS_OF_SUPPLIER_SUCCESS";
export const LOAD_SALES_ORDERS_OF_SUPPLIER_FAILURE = "LOAD_SALES_ORDERS_OF_SUPPLIER_FAILURE";

export const CREATE_SALES_ORDER_REQUEST = "CREATE_SALES_ORDER_REQUEST";
export const CREATE_SALES_ORDER_SUCCESS = "CREATE_SALES_ORDER_SUCCESS";
export const CREATE_SALES_ORDER_FAILURE = "CREATE_SALES_ORDER_FAILURE";

export const CANCEL_SALES_ORDER_REQUEST = "CANCEL_SALES_ORDER_REQUEST";
export const CANCEL_SALES_ORDER_SUCCESS = "CANCEL_SALES_ORDER_SUCCESS";
export const CANCEL_SALES_ORDER_FAILURE = "CANCEL_SALES_ORDER_FAILURE";

export const CLIENT_CHANGE_REQUEST = "CLIENT_CHANGE_REQUEST";
export const CLIENT_CHANGE_SUCCESS = "CLIENT_CHANGE_SUCCESS";
export const CLIENT_CHANGE_FAILURE = "CLIENT_CHANGE_FAILURE";

export const CLIENT_REMOVE_REQUEST = "CLIENT_REMOVE_REQUEST";
export const CLIENT_REMOVE_SUCCESS = "CLIENT_REMOVE_SUCCESS";
export const CLIENT_REMOVE_FAILURE = "CLIENT_REMOVE_FAILURE";

export const CARD_CANCEL_IN_WORK_REQUEST = "CARD_CANCEL_IN_WORK_REQUEST";
export const CARD_CANCEL_IN_WORK_FAILURE = "CARD_CANCEL_IN_WORK_FAILURE";
export const CARD_IN_WORK_REQUEST = "CARD_IN_WORK_REQUEST";
export const CARD_IN_WORK_FAILURE = "CARD_IN_WORK_FAILURE";

export const EXPORT_DATA_REQUEST = "EXPORT_DATA_REQUEST";
export const EXPORT_DATA_SUCCESS = "EXPORT_DATA_SUCCESS";
export const EXPORT_DATA_FAILURE = "EXPORT_DATA_FAILURE";

export const CLIENTS_EXPORTED_REQUEST = "CLIENTS_EXPORTED_REQUEST";
export const CLIENTS_EXPORTED_SUCCESS = "CLIENTS_EXPORTED_SUCCESS";
export const CLIENTS_EXPORTED_FAILURE = "CLIENTS_EXPORTED_FAILURE";

export const CLEAR_EXPORT_LINK = "CLEAR_EXPORT_LINK";

export const UPDATE_COEFFICIENT_REQUEST = "UPDATE_COEFFICIENT_REQUEST";
export const UPDATE_COEFFICIENT_SUCCESS = "UPDATE_COEFFICIENT_SUCCESS";
export const UPDATE_COEFFICIENT_FAILURE = "UPDATE_COEFFICIENT_FAILURE";

export const UPDATE_MARGIN_REQUEST = "UPDATE_MARGIN_REQUEST";
export const UPDATE_MARGIN_SUCCESS = "UPDATE_MARGIN_SUCCESS";
export const UPDATE_MARGIN_FAILURE = "UPDATE_MARGIN_FAILURE";

export const SET_COEFFICIENT_REQUEST = "SET_COEFFICIENT_REQUEST";
export const SET_COEFFICIENT_SUCCESS = "SET_COEFFICIENT_SUCCESS";
export const SET_COEFFICIENT_FAILURE = "SET_COEFFICIENT_FAILURE";

export const LOAD_CULTURES_BY_CATEGORY_REQUEST =
  "LOAD_CULTURES_BY_CATEGORY_REQUEST";
export const LOAD_CULTURES_BY_CATEGORY_SUCCESS =
  "LOAD_CULTURES_BY_CATEGORY_SUCCESS";
export const LOAD_CULTURES_BY_CATEGORY_FAILURE =
  "LOAD_CULTURES_BY_CATEGORY_FAILURE";

export const LOAD_CULTURES_REQUEST = "LOAD_CULTURES_REQUEST";
export const LOAD_CULTURES_SUCCESS = "LOAD_CULTURES_SUCCESS";
export const LOAD_CULTURES_FAILURE = "LOAD_CULTURES_FAILURE";

export const SAVE_CULTURE_REQUEST = "SAVE_CULTURE_REQUEST";
export const SAVE_CULTURE_SUCCESS = "SAVE_CULTURE_SUCCESS";
export const SAVE_CULTURE_FAILURE = "SAVE_CULTURE_FAILURE";

export const DELETE_CULTURE_REQUEST = "DELETE_CULTURE_REQUEST";
export const DELETE_CULTURE_SUCCESS = "DELETE_CULTURE_SUCCESS";
export const DELETE_CULTURE_FAILURE = "DELETE_CULTURE_FAILURE";

export const LOAD_TASKS_ACTUAL_REQUEST = "LOAD_TASKS_ACTUAL_REQUEST";
export const LOAD_TASKS_ACTUAL_SUCCESS = "LOAD_TASKS_ACTUAL_SUCCESS";
export const LOAD_TASKS_ACTUAL_FAILURE = "LOAD_TASKS_ACTUAL_FAILURE";

export const LOAD_TASKS_FINISHED_REQUEST = "LOAD_TASKS_FINISHED_REQUEST";
export const LOAD_TASKS_FINISHED_SUCCESS = "LOAD_TASKS_FINISHED_SUCCESS";
export const LOAD_TASKS_FINISHED_FAILURE = "LOAD_TASKS_FINISHED_FAILURE";

export const CULTURE_IN_WORK_CHANGE_REQUEST = "CULTURE_IN_WORK_CHANGE_REQUEST";
export const CULTURE_IN_WORK_CHANGE_SUCCESS = "CULTURE_IN_WORK_CHANGE_SUCCESS";
export const CULTURE_IN_WORK_CHANGE_FAILURE = "CULTURE_IN_WORK_CHANGE_FAILURE";

export const CLIENTS_IN_PROFIT_LOAD_REQUEST = "CLIENTS_IN_PROFIT_LOAD_REQUEST";
export const CLIENTS_IN_PROFIT_LOAD_SUCCESS = "CLIENTS_IN_PROFIT_LOAD_SUCCESS";
export const CLIENTS_IN_PROFIT_LOAD_FAILURE = "CLIENTS_IN_PROFIT_LOAD_FAILURE";

export const WAIT_FOR_CALL_CLIENTS_LOAD_REQUEST =
  "WAIT_FOR_CALL_CLIENTS_LOAD_REQUEST";
export const WAIT_FOR_CALL_CLIENTS_LOAD_SUCCESS =
  "WAIT_FOR_CALL_CLIENTS_LOAD_SUCCESS";
export const WAIT_FOR_CALL_CLIENTS_LOAD_FAILURE =
  "WAIT_FOR_CALL_CLIENTS_LOAD_FAILURE";

export const ADD_TASK_REQUEST = "ADD_TASK_REQUEST";
export const ADD_TASK_SUCCESS = "ADD_TASK_SUCCESS";
export const ADD_TASK_FAILURE = "ADD_TASK_FAILURE";

export const UPDATE_TASK_REQUEST = "UPDATE_TASK_REQUEST";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const UPDATE_TASK_FAILURE = "UPDATE_TASK_FAILURE";

export const REMOVE_TASK_REQUEST = "REMOVE_TASK_REQUEST";
export const REMOVE_TASK_SUCCESS = "REMOVE_TASK_SUCCESS";
export const REMOVE_TASK_FAILURE = "REMOVE_TASK_FAILURE";

export const CALC_MAP_PRICE_REQUEST = "CALC_MAP_PRICE_REQUEST";
export const CALC_MAP_PRICE_SUCCESS = "CALC_MAP_PRICE_SUCCESS";
export const CALC_MAP_PRICE_FAILURE = "CALC_MAP_PRICE_FAILURE";

export const CLEAR_ALERT_MESSAGES = "CLEAR_ALERT_MESSAGES";

export const LOAD_CHANGING_REQUEST = "LOAD_CHANGING_REQUEST";
export const LOAD_CHANGING_SUCCESS = "LOAD_CHANGING_SUCCESS";
export const LOAD_CHANGING_FAILURE = "LOAD_CHANGING_FAILURE";

export const FILTERS_LOAD_REQUEST = "FILTERS_LOAD_REQUEST";
export const FILTERS_LOAD_SUCCESS = "FILTERS_LOAD_SUCCESS";
export const FILTERS_LOAD_FAILURE = "FILTERS_LOAD_FAILURE";



// WEBPACK FOOTER //
// ./constants/actionsTypes.js